<template>
  <v-fab-transition>
    <v-btn
      icon="mdi-chevron-up"
      size="small"
      class="app-fab app-fab--bottom"
      color="primary"
      v-show="fab"
      @click="toTop"
    ></v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  name: 'app-fab',

  data: () => ({
    fab: false,
  }),
  created() {
    window.addEventListener('scroll', this.onScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      if (typeof window === 'undefined') {
        return;
      }

      const top = window.pageYOffset || document.documentElement.offsetTop || 0;

      this.fab = top > 300;
    },
    toTop() {
      this.$router.push({ hash: '' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.app-fab {
  position: fixed;
  z-index: 5;
}

.app-fab--bottom {
  right: 16px;
  bottom: 16px;
}
</style>
